import React from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Typography from "@mui/material/Typography";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useDispatch } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
// import { deleteSingleTeamLeader } from "../../../Store/PHPSlice/TeamLeader";

const TableBody = ({
  id,
  teamLeaderName,
  date, // ✅ ADD THIS
  serialNumber,
}) => {
  const dispatch = useDispatch();
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const handleEditClick = () => {
    window.open(
      `/team-leader-edit/${id}`,
      "_blank",
      "width=800,height=600,scrollbars=yes,resizable=yes"
    );
  };

  const handleDeleteClick = () => {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this Team Leader?"
    );

    if (isConfirmed) {
      fetchDeleteTeamLeader(id);
    }
  };

  const fetchDeleteTeamLeader = async (id) => {
    try {
      const response = await axios.delete(
        `${baseUrl}?apicall=deleteTeamLeader&teamId=${id}`
      );
      const result = response.data;
      if (result.status === "success") {
        alert(result.msg);
        window.location.reload();
      } else {
        alert(result.msg[0]);
      }
    } catch (error) {
      console.error("Error deleting Team Leader:", error);
    }
  };

  return (
    <>
      <TableRow hover>
        <TableCell sx={{ p: 1, border: "1px solid #000" }} align="center">
          {serialNumber}
        </TableCell>

        <TableCell sx={{ p: 1, border: "1px solid #000" }} align="center">
          {date}
        </TableCell>

        <TableCell sx={{ p: 1, border: "1px solid #000" }} align="center">
          <Typography variant="subtitle2" noWrap>
            {teamLeaderName}
          </Typography>
        </TableCell>

        <TableCell sx={{ p: 1, border: "1px solid #000" }} align="center">
          <EditIcon className="cursor-pointer" onClick={handleEditClick} />
        </TableCell>

        <TableCell sx={{ p: 1, border: "1px solid #000" }} align="center">
          <DeleteIcon className="cursor-pointer" onClick={handleDeleteClick} />
        </TableCell>
      </TableRow>
      <ToastContainer />
    </>
  );
};

export default TableBody;
